import { logger } from "@/observability/logger";

// Returns the app-wide Datadog Browser Logs logger (replaces the WebX host
// child logger). Kept as a hook so existing call sites need no change.
export const useLogger = () => logger;
